import {
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import dayjs from 'dayjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '@lmc-app/custom-function.service';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';
import { NgIf, NgFor, CurrencyPipe } from '@angular/common';

@Component({
	selector: 'app-nlsagencycollectors',
	templateUrl: './nlsagencycollectors.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./nlsagencycollectors.component.scss'],
	imports: [NgIf, NgFor, CurrencyPipe],
})
export class NlsagencycollectorsComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private router: ActivatedRoute,
		private apiService: LegacyApiService,
		private customFunction: CustomFunctionService,
		private _routerLink: Router,
		private store: Store<State>
	) {}

	agencyName: string;
	monthNum = dayjs().month();
	collectorsArray: any;

	countCollectedMonth: any;
	totalCollectedfundedMonth: any;

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					// Get the collector name from the nlsAgencyFunded page
					this.router.queryParams.subscribe((params) => {
						((this.agencyName = params['agency']),
							(this.monthNum = params['monthNum']));
					});

					// Send the Agency name to get the collectors listed under the agency
					this.apiService
						.getNLSAgencyCollectors(this.agencyName, this.monthNum)
						.subscribe((res) => {
							this.collectorsArray = res.data;

							this.countCollectedMonth = this.customFunction.sumNumbers(
								this.collectorsArray,
								'CollecterCount'
							);
							this.totalCollectedfundedMonth = this.customFunction.sumNumbers(
								this.collectorsArray,
								'TotalAmount'
							);
						});
				}
			});
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
